import React, { useState, useEffect } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import {
  Breadcrumb,
  Row,
  Col,
  Typography,
  Affix,
  Spin,
  Button,
  message,
} from "antd";
import successPng from "../../../assets/images/collection-created.svg";
import Axios from "axios";
import { Colors } from "../../../theme";
import fileDownload from "js-file-download";
import LoadingModal from "../LoadingModal";
import { useTracking } from "react-tracking";
import { PPT_DOWNLOADED, EXCEL_DOWNLOADED } from "../../../analytics/events";

const { Text, Paragraph, Title } = Typography;
export default function Success() {
  const [spinning, setspinning] = useState(false);
  const history = useHistory();
  const params = useParams();
  const [collectionDetails, setCollectionDetails] = useState(null);
  const [fileType, setFileType] = useState("");
  const collectionLink = params?.id;
  const [error, setError] = useState(false);
  const user = localStorage.getItem("user");
  const { trackEvent } = useTracking();

  const success = () => {
    navigator.clipboard.writeText(
      `${process.env.REACT_APP_URL}${collectionLink}`
    );
    const success = message.success("Copied to Clipboard");
    setTimeout(success, 2000);
  };
  const downloadExcel = () => {
    setError(false);
    setFileType("Excel");
    setspinning(true);

    const token = JSON.parse(user).access_token;
    Axios.get(
      `${process.env.REACT_APP_API_SERVICE}xlsservice/v2/?collection_link=${collectionLink}&token=${token}`,
      {
        responseType: "blob",
      }
    )
      .then((res) => {
        const collection_info = sessionStorage.getItem("collectionDetails");
        const details = JSON.parse(collection_info);
        fileDownload(res.data, `${details?.collection_name}.xlsx`);
        setspinning(false);
        trackEvent({
          name: EXCEL_DOWNLOADED,
          meta: {
            collection_id: collectionDetails?.id ?? "",
            collection_name: collectionDetails?.collection_name ?? "",
            collection_link: collectionLink,
          },
        });
      })
      .catch((err) => {
        setError(true);
        setspinning(false);
        setFileType("");
      });
  };

  const downloadPPT = () => {
    setError(false);
    setFileType("PPT");
    setspinning(true);

    Axios.get(
      `${process.env.REACT_APP_API_SERVICE}pptservice/?collection_link=${collectionLink}`
    )
      .then((res) => {
        // console.log(res.data, "res.data");
        window.open(res?.data?.ppt_url, "_self");
        // fileDownload(res.data, `${collectionDetails?.collection_name}.pptx`);
        setspinning(false);
        trackEvent({
          name: PPT_DOWNLOADED,
          meta: {
            collection_id: collectionDetails?.id ?? "",
            collection_name: collectionDetails?.collection_name ?? "",
            collection_link: collectionLink,
          },
        });
      })
      .catch((err) => {
        setError(true);
        setspinning(false);
        setFileType("");
      });
  };
  useEffect(() => {
    if (sessionStorage.getItem("collectionDetails")) {
      setCollectionDetails(
        JSON.parse(sessionStorage.getItem("collectionDetails"))
      );
    }
  }, []);
  return (
    <div>
      <LoadingModal visible={spinning} fileType={fileType} error={error} />
      <Row>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/"> Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/master-catalogue">Generate Catalogue link</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      </Row>

      {/* <Spin spinning={spinning} size="large"> */}
      <Row justify="center">
        <Col span={24}>
          <Row justify="center" style={{ marginTop: "2rem" }}>
            <Col>
              <img src={successPng} alt="success" width="100%" height="100%" />
            </Col>
          </Row>

          <Row justify="center" style={{ marginTop: "2rem" }}>
            <Col>
              <Title level={4}>
                Copy the link below and share it with the buyer on email{" "}
              </Title>
            </Col>
          </Row>

          <Row justify="center" style={{ marginTop: "1rem" }}>
            <Col>
              <Text level={3}>
                We will update you whenever the buyer opens the catalogue link,
                shortlists products or shares any queries{" "}
              </Text>
            </Col>
          </Row>

          <Row justify="center" style={{ marginTop: "3rem" }}>
            <Col span={8}>
              <span>
                <Paragraph
                  copyable
                  style={{
                    padding: "1rem 2rem",
                    border: "1px solid #CDCFCE",
                    borderRadius: "4px",
                    color: "#0B7764",
                    fontSize: "14px",
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  {`${process.env.REACT_APP_URL}${collectionLink}`}
                </Paragraph>
              </span>
            </Col>
          </Row>

          <Row justify="center" style={{ marginTop: "4rem" }}>
            <Col span={4}>
              <Button
                size="large"
                style={{
                  width: "90%",
                  color: Colors.primaryColor,
                  backgroundColor: Colors.primaryColorTint,
                  border: `1px solid ${Colors.primaryColor}`,
                  marginRight: "4rem",
                }}
                onClick={() => downloadExcel()}
              >
                Download Excel
              </Button>
            </Col>
            <Col span={4}>
              <Button
                type="primary"
                size="large"
                style={{
                  width: "90%",
                }}
                onClick={() => downloadPPT()}
              >
                Download PPT
              </Button>
            </Col>
            <Col span={4}>
              <Button
                size="large"
                style={{
                  width: "90%",
                  color: Colors.white,
                  backgroundColor: "#363E3D",
                  border: 0,
                }}
                type="primary"
                onClick={() => success()}
              >
                Copy Catalogue Link
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
      {/* </Spin> */}

      {/* <Row justify="center" style={{ marginTop: "20px" }}>
        <Col>
          <Row justify="center" style={{ marginTop: "48px" }}>
            <Row> 
            <Col span={12}>
              <img src={successPng} alt="success" width="100%" height="100%" />
            </Col>
            </Row>
            <Text
              style={{
                textAlign: "center",
                fontFamily: "Avenir",
                fontSize: "16px",
                lineHeight: "28px",
                width: "591px",
                color: "#040E0C",
                marginTop: "30px",
              }}
            >
              Copy the link below and share it with the buyer on email. We will
              send updates at registered email addresss when the buyer opens the
              link, shortlist or shares any queries
            </Text>
          </Row>
          <Row
            justify="center"
            style={{ marginTop: "4rem", marginBottom: "4rem" }}
          >
            <Space>
              <span>
                <Paragraph
                  copyable
                  style={{
                    padding: "1rem 2rem",
                    border: "1px solid #CDCFCE",
                    borderRadius: "4px",
                    color: "#0B7764",
                    fontSize: "14px",
                    width:'100%'
                  }}
                >
                  {`https://catalogue.sourcewiz.co/${collectionLink}`}
                </Paragraph>
              </span>
            </Space>
          </Row>
          <Row justify="center" style={{ marginBottom: "4rem" }}>
          
              <Col span={8}>
                <a href={`https://catalogue.sourcewiz.co/${collectionLink}`} target="_blank">
                  <Button
                    size="large"
                    style={{
                      width: "90%",
                      color: Colors.white,
                      backgroundColor: "#363E3D",
                      marginRight: "4rem",
                    }}
                    type="primary"

                  >
                    View Collection
                  </Button>
                </a>
                </Col>
                <Col span={8}>
                <Button
                  size="large"
                  style={{ width: "90%", backgroundColor: "#0B7764" }}
                  type="primary"
                  onClick={success}
                >
                  Copy Collection Link
                </Button>
              </Col>

              <Col span={8}>
              <Button
              size="large"
              style={{ width: "90%" }}
              type="default"
              onClick={() => history.push("/")}
            >
              Home
            </Button></Col>
        
          </Row>
          <Row justify="center">
            
          </Row>
        </Col>
      </Row> */}
    </div>
  );
}
